import { render, staticRenderFns } from "./cprs-footer.component.vue?vue&type=template&id=31758784"
import script from "./cprs-footer.component?vue&type=script&lang=ts&external"
export * from "./cprs-footer.component?vue&type=script&lang=ts&external"
import style0 from "./cprs-footer.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports